export const LineLeftIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="53"
            height="1"
            viewBox="0 0 53 1"
            fill="none"
        >
            <path d="M52.5337 0.5H0.0336914" stroke="url(#paint0_linear_4433_20554)" />
            <defs>
                <linearGradient
                    id="paint0_linear_4433_20554"
                    x1="52.5337"
                    y1="1.00014"
                    x2="-1.07546"
                    y2="1.00012"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stop-color="#E53223" />
                    <stop offset="1" stop-color="#E8E8E8" stop-opacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
};
